import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '../Components/Home/Home';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import Zone from '../Components/Zone/Zone';
import ScrollToTop from './scrollToTop';
import PricingCards from '../Components/Prices/Prices';
import DubaiZonesInfo from '../Components/Freezone/Freezone';
import BlogTemplate from '../Components/Blogs/blog1';
import { HelmetProvider } from 'react-helmet-async';
import ButtonContact from '../Components/Button/Button-contact';
import ServicesSection from '../Components/Services/Services';
import BlogRealEstate from '../Components/Blogs/blog2';
import BlogDubaiBusiness from '../Components/Blogs/blog3';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter className="app">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/dubai-work-zones" element={<Zone />} />
          <Route path="/pricing" element={<PricingCards />} />
          <Route path="/zones-info-dubai" element={<DubaiZonesInfo />} />
          <Route path='/how-to-create-a-business-in-dubai' element={<BlogTemplate />} />
          <Route path="/services" element={<ServicesSection />}/>
          <Route path="/how-to-maximize-your-real-state-investments-in-dubai" element={<BlogRealEstate />}/>
          <Route path='/why-dubai-is-the-ultimate-destination-for-entrepreneurs-in-2024' element={<BlogDubaiBusiness />}/>
        </Routes>
        <Footer />
      </BrowserRouter>
      <ButtonContact />
    </HelmetProvider>
  );
}

export default App;
